<template>
  <section>
    <v-dialog v-model="processDialog" max-width="750" persistent>
      <v-skeleton-loader
        v-if="isLoading"
        type="table"
        class="pa-5"
        style="background: white"
      >
        <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
      </v-skeleton-loader>
      <v-data-table v-else :headers="processTableHeaders" :items="Process">
        <template v-slot:[`item.question`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.question.name"
                ></v-list-item-title>
              </v-list-item-content>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="text--darken-1 font-weight-medium"
                  v-html="item.question.name"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
        <template v-slot:[`item.critical`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.critical ? 'Si' : 'No'"
                ></v-list-item-title>
              </v-list-item-content>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="text--darken-1 font-weight-medium"
                  v-html="item.critical ? 'Si' : 'No'"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="editProcess(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'error' : 'blue-grey'"
              @click.stop="deleteProcess(item)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
      <v-container style="background-color: white">
        <v-row justify="end" class="pr-4" align="center">
          <v-col cols="2">
            <v-progress-circular
              v-if="!isLoading"
              :rotate="-90"
              :size="40"
              :width="5"
              :value="ProgressValue"
              color="primary"
            >
              {{ ProgressValue }}
            </v-progress-circular>
            <!-- <v-progress-circular :value="ProgressValue"></v-progress-circular> -->
            <!-- <v-card-text>{{ProgressValue}}%</v-card-text> -->
          </v-col>
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closeDialog"
              >Cerrar</v-btn
            >
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click.stop="registerProcess()"
              >Añadir</v-btn
            >
          </v-hover>
        </v-row>
      </v-container>
    </v-dialog>
    <ProcessForm
      v-if="formDialog"
      :formDialog="formDialog"
      :idEvaluation="idEvaluation"
      @processFormDialog:close="closeFormDialog"
      :dataToForm="dataToForm"
      :mode="formMode"
    />
    <DeleteDialog
      v-if="deleteDialog"
      :dialogProp="deleteDialog"
      mode="evaluationProcess"
      :item="itemToDelete"
      @dialog:close="closeDeleteProcess"
    />
  </section>
</template>

<script>
import ProcessForm from "@/components/EvaluationProcess/ProcessForm";
import DeleteDialog from "@/components/Utils/DeleteDialog";
export default {
  components: { ProcessForm, DeleteDialog },
  props: {
    processDialog: {
      type: Boolean,
      default: false,
    },
    idEvaluation: {
      type: Number,
    },
  },
  data() {
    return {
      isLoading: true,
      processTableHeaders: [
        {
          text: "Pregunta",
          align: "left",
          sortable: true,
          value: "question",
          class: "primary--text",
          width: "40%",
        },
        {
          text: "Critico",
          align: "left",
          sortable: true,
          value: "critical",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Valor",
          align: "left",
          sortable: true,
          value: "value",
          class: "primary--text",
          width: "25%",
        },
        {
          text: "Acciones",
          align: "left",
          value: "action",
          class: "primary--text",
          width: "15%",
        },
      ],
      //Add-Edit
      formMode: "",
      formDialog: false,
      dataToForm: {},
      //Delete
      deleteDialog: false,
      itemToDelete: null,
    };
  },
  created() {
    // console.log("working...");
    this.getProcess();
  },
  computed: {
    Process() {
      return this.$store.getters["process/GET_ALL_PROCESS"];
    },
    ProgressValue() {
      return this.Process.reduce((prev, next) => {
        return prev + next.value;
      }, 0);
    },
  },
  methods: {
    deleteProcess(item) {
      (this.deleteDialog = true), (this.itemToDelete = item);
    },
    closeDeleteProcess() {
      (this.deleteDialog = false), (this.itemToDelete = null);
    },
    closeFormDialog() {
      this.formDialog = false;
      this.dataToForm = {};
      this.itemToDelete = false;
      this.getProcess();
    },
    registerProcess() {
      this.formMode = "register";
      this.formDialog = true;
    },
    editProcess(item) {
      this.formDialog = true;
      this.formMode = "edit";
      this.dataToForm = item;
    },
    closeDialog() {
      this.$emit("dialog:close");
    },
    async getProcess() {
      this.isLoading = true;
      await this.$store.dispatch("process/SHOW_PROCESS", this.idEvaluation);
      this.isLoading = false;
    },
  },
};
</script>
